export default __webpack_public_path__ + "static/539-2b01370ac918731c1652cdb231d6025e.gif";